import React from 'react';

export const ArrowUp: React.FC<{ wrapperClass?: string }> = ({
	wrapperClass,
	...props
}) => (
	<svg
		className={wrapperClass}
		{...props}
		viewBox="0 0 1792 1792"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M1277 493q-9 19-29 19h-224v1248q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-1248h-224q-21 0-29-19t5-35l350-384q10-10 23-10 14 0 24 10l355 384q13 16 5 35z" />
	</svg>
);

export const ArrowDown: React.FC<{ wrapperClass?: string }> = ({
	wrapperClass,
	...props
}) => (
	<svg
		className={wrapperClass}
		{...props}
		viewBox="0 0 1792 1792"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M1277 1299q8 19-5 35l-350 384q-10 10-23 10-14 0-24-10l-355-384q-13-16-5-35 9-19 29-19h224v-1248q0-14 9-23t23-9h192q14 0 23 9t9 23v1248h224q21 0 29 19z" />
	</svg>
);
